<template>
    <b-form-group>
        <template slot="label">
            <span>{{ $t('values.questionnaires') }}</span>
        </template>
        <multiselect
            id="questionnaires"
            :state="state"
            :selected="value"
            :options="options"
            :loading="isLoading"
            :disabled="disabled"
            :groupSelect="enableSelectAll"
            :closeOnSelect="closeOnSelect"
            :placeholder="$t('form.placeholder.select')"
            @changeValue="onChangeValue"
            @click="getQuestionnaires()"
        />
    </b-form-group>
</template>

<script>
import { getQuestionnaires } from '@/views/values/api'
import { Multiselect, mapperToOptions } from '@/views/components/selects'

export default {
    name: 'Questionnaires',
    components: {
        Multiselect,
    },
    props: {
        value: {
            type: Array | null,
            required: true,
        },
        showLabel: {
            type: Boolean,
            default: true,
        },
        closeOnSelect: {
            type: Boolean,
            default: true,
        },
        state: {
            type: Boolean,
            default: null,
        },
        disabled: Boolean,
        enableSelectAll: Boolean,
    },
    data() {
        return {
            options: [],
            isLoaded: false,
            isLoading: false,
        }
    },
    mounted() {
        this.getQuestionnaires().finally(() => {
            if (this.options.length == 0) {
                this.$emit('without-options-available')
            }
            this.$emit('ready')
        })
    },
    methods: {
        onChangeValue(event) {
            this.$emit('update:value', event)
            this.$emit('change')
        },
        getQuestionnaires() {
            this.isLoading = true
            return getQuestionnaires({
                ascending: 1,
                orderBy: 'name',
                scopes: 'hasFeedbacks',
            })
                .then(questionnaires => {
                    this.options = mapperToOptions(questionnaires).map(opt => {
                        const index = questionnaires.findIndex(
                            e => e.questionnaire_id == opt.id
                        )
                        return {
                            ...opt,
                            networkTypes: questionnaires[index].network_types,
                            evaluateds: questionnaires[index].evaluateds,
                        }
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>
